// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ce9d9a{position:relative;flex:1}.ce9d9a:last-child{border-bottom:1px solid var(--subtle)}.ce9d9a+.ce9d9a{border-top:1px solid var(--subtle)}@media print{.ce9d9a{display:none}}.bd0565{position:absolute;top:0;right:0;bottom:0;left:0;display:flex;align-items:center;justify-content:center;font-weight:600;gap:.5em;white-space:nowrap;box-shadow:none !important;font-size:.875em}.bd0565[aria-expanded] [data-chevron]{transform:rotate(-180deg) scale(1.25)}._8c14de{--background: none;box-shadow:none;padding:0 !important}._8c14de .b393bf{background:var(--body-background)}._8c14de .b393bf>*{margin:0 0 .25em}", ""]);
// Exports
exports.locals = {
	"wrapper": "ce9d9a",
	"collapsed": "bd0565",
	"popup": "_8c14de",
	"cards": "b393bf"
};
module.exports = exports;
